import 'slick-carousel';

const $sliders = $('.js-activities-exp-container');

if ($sliders.length) {
  Array.forEach($sliders, $slider => {
    const slider = $slider.querySelector('.js-activities-exp-carousel');
    const nextButton = $slider.querySelector('.js-button-next');
    const prevButton = $slider.querySelector('.js-button-prev');
    initCarousel(slider, nextButton, prevButton);
  });
}

function initCarousel(slider, nextButton, prevButton) {
  const items = $(slider).find('.exp-carousel__item');
  const images = $(slider).find('.js-activities-exp-image');
  let imagesLoaded = 0;

  images.each((i, e) => {
    if (e.complete) {
      imagesLoaded += 1;

      if (imagesLoaded === images.length) {
        initialiseSlider(slider, items, nextButton, prevButton);
      }
    } else {
      $(e).on('load', () => {
        imagesLoaded += 1;

        if (imagesLoaded === images.length) {
          initialiseSlider(slider, items, nextButton, prevButton);
        }
      });
    }
  });
}

function initialiseSlider(slider, items, nextButton, prevButton) {
  // Bind the buttons event before init
  $(slider).on('init breakpoint', () => {
    if (items.length !== 1) {
      if (nextButton !== null) {
        nextButton.addEventListener('click', () => $(slider).slick('slickNext'));
      }

      if (prevButton !== null) {
        prevButton.addEventListener('click', () => $(slider).slick('slickPrev'));
      }
    } else {
      $(nextButton).hide();
      $(prevButton).hide();
    }
  });

  // Init slider
  $(slider).slick({
    dots: false,
    infinite: false,
    speed: 700,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: true,
    arrows: false,
    swipeToSlide: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          adaptiveHeight: true,
        },
      },
    ],
  });
}
